import React from 'react'
import Page, { usePage } from 'contexts/page'
import EntitiesClientStateProvider from 'state/entities'
import { getDateRangeDefault, adaptParams } from 'pages/activity-log/utilities'
import { Title } from 'components/typography/heading'
import Content from './content'

const ActivityLogPage = props => {
    const { title } = usePage()

    return (
        <>
            <Title>{title}</Title>
            <Content {...props} />
        </>
    )
}

export default props => (
    <Page
        view="activity_log"
        title={{
            id: 'noun_activity_log',
            defaultMessage: 'Activity log'
        }}>
        <EntitiesClientStateProvider
            queryOptions={{ key: ['audit'] }}
            path="/audit"
            filter={{ dateRange: getDateRangeDefault() }}
            paging={{ limit: 50 }}
            adaptParams={adaptParams}>
            <ActivityLogPage {...props} />
        </EntitiesClientStateProvider>
    </Page>
)